
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import {userApi} from '@/api';

@Component
export default class Class_Course_Info extends Vue {
    @Prop({default: {}}) teacherInfo?: any;
    @Emit('closeModal') private closeModal() {}
    //===================================data区域begin
    loading: boolean = false;
    teacherId: string = '';
    classNum: number = 0;
    courseNum: number = 0;
    // 表格记录 hover 状态
    leftAlignId: any = '';
    columns: any = [
        {
            dataIndex: 'teacherName',
            title: '教师名称',
            scopedSlots: {
                customRender: ''
            },
            customRender: (value: any, row: any, index: any) => {
                const obj: any = {
                    children: value,
                    attrs: {}
                };
                // 合并教师名称列
                if (index === 0) {
                    obj.attrs.rowSpan = this.pager.rows.length;
                }
                for (let i = 1; i < this.pager.rows.length; i++) {
                    if (index == i) {
                        obj.attrs.colSpan = 0;
                    }
                }
                return obj;
            }
        },
        {
            dataIndex: 'className',
            title: '班级名称',
            scopedSlots: {
                customRender: 'className'
            },
            customRender: (value: any, row: any, index: any) => {
                // 合并班级名称列
                const obj: any = {
                    children: value,
                    attrs: {}
                };
                // 筛选出相同 classId 的 rows 数据
                let arr = this.pager.rows.filter((res: any) => {
                    return res.classId == row.classId;
                });
                // 不渲染相同 classId 的 row
                if (index == 0 || this.pager.rows[index - 1].classId != row.classId) {
                    obj.attrs.rowSpan = arr.length;
                } else {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            }
        },
        {
            dataIndex: 'courseName',
            title: '课程名称',
            scopedSlots: {
                customRender: 'courseName'
            }
        }
    ];
    pager: any = {
        pagesize: 200,
        pagenum: 1,
        total: 0,
        rows: []
    };
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    handleCancel() {
        this.$emit('closeModal');
    }
    getInfo() {
        let me = this;
        me.loading = true;
        let urlParamObj = {
            teacherId: me.teacherId
        };
        userApi.getTeacherClassCourse({
            urlParams: urlParamObj,
            success(data: any, parameters: any) {
                let dataList = data.data.list[0];
                // console.log(dataList);
                for (let i = 0; i < dataList.courseClassData.length; i++) {
                    dataList.courseClassData[i].teacherName = me.teacherInfo.nickname;
                    dataList.courseClassData[i].index = i;
                }
                dataList.courseClassData.sort((a: any, b: any) => b.className.localeCompare(a.className));
                me.pager.rows = dataList.courseClassData;
                me.loading = false;
            },
            error(error: any, message: any, parameters: any) {
                me.$message.error(message);
                me.loading = false;
            }
        });
    }
    //===================================methods区域end
    created() {
        // console.log(this);
        if (this.teacherInfo) {
            this.teacherId = this.teacherInfo._id;
            this.classNum = this.teacherInfo.classCount;
            this.courseNum = this.teacherInfo.courseCount;
        }
        this.getInfo();
    }
}
